'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { Spinner } from '../Spinner/Spinner.js';

const StyledContentLoader = styled(ContentLoader).withConfig({
  shouldForwardProp: (prop, defaultValidationFn) => defaultValidationFn(prop)
}).withConfig({
  componentId: "sc-6awgwv-0"
})(["", ""], ({
  spaceAfter
}) => spaceProp(spaceAfter));
const Loader = /*#__PURE__*/withTitan(({
  height,
  width = '100%',
  spaceAfter,
  variant = 'paragraph',
  testId = 'loader'
}) => {
  switch (variant) {
    case 'paragraph':
      return jsxs(StyledContentLoader, {
        animate: false,
        "data-test-class": "loaderParagraph",
        "data-test-id": `${testId}Paragraph`,
        height: height,
        spaceAfter: spaceAfter,
        width: width,
        children: [jsx("rect", {
          height: "25%",
          rx: "2",
          ry: "2",
          width: "80%",
          x: "0",
          y: "0"
        }), jsx("rect", {
          height: "15%",
          rx: "1",
          ry: "1",
          width: "94%",
          x: "0",
          y: "35%"
        }), jsx("rect", {
          height: "15%",
          rx: "1",
          ry: "1",
          width: "90%",
          x: "0",
          y: "60%"
        }), jsx("rect", {
          height: "15%",
          rx: "1",
          ry: "1",
          width: "94%",
          x: "0",
          y: "85%"
        })]
      });
    case 'skeleton':
      return jsx(StyledContentLoader, {
        animate: false,
        "data-test-class": "loaderSkeleton",
        "data-test-id": `${testId}Skeleton`,
        height: height,
        spaceAfter: spaceAfter,
        width: width,
        children: jsx("rect", {
          height: "100%",
          rx: "2",
          ry: "2",
          width: "100%",
          x: "0",
          y: "0"
        })
      });
    /**
     * @deprecated This variant is deprecated. Use <Spinner /> instead.
     */
    case 'spinner':
      return jsx(Spinner, {
        size: height,
        spaceAfter: spaceAfter,
        testId: `${testId}Spinner`,
        width: width
      });
    default:
      return null;
  }
}, {
  name: 'Loader',
  memo: true
});

export { Loader };
//# sourceMappingURL=Loader.js.map
